/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Notifications_Toast_Delete_ErrorInputs */

const he_account_notifications_toast_delete_error = /** @type {(inputs: Account_Notifications_Toast_Delete_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שגיאה במחיקת ההתראה`)
};

const en_account_notifications_toast_delete_error = /** @type {(inputs: Account_Notifications_Toast_Delete_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to delete notification`)
};

/**
* | output |
* | --- |
* | "Failed to delete notification" |
*
* @param {Account_Notifications_Toast_Delete_ErrorInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_notifications_toast_delete_error = /** @type {((inputs?: Account_Notifications_Toast_Delete_ErrorInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Notifications_Toast_Delete_ErrorInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_notifications_toast_delete_error(inputs)
	return en_account_notifications_toast_delete_error(inputs)
});